import { useTranslation } from 'react-i18next';
import { OfferCardProps } from '..';
import { useCurrencies } from '../../../contexts/currencies-context';
import { useOffers } from '../../../contexts/offers';
import { useOfferDescription } from '../../../hooks/use-offer-description';
import { BaseOffer } from '../../../types/offers';

export const useMapBaseOfferToProps = () => {
  const { t, i18n } = useTranslation();
  const { selectedOfferType } = useOffers();
  const { selectedCurrency, selectedCountryInfo } = useCurrencies();
  const currentLang = i18n.language;
  const { getOfferDescription } = useOfferDescription();

  const getButtonText = (isSoldOut: boolean, isLimitReached: boolean, price: number, symbol?: string) => {
    if (isSoldOut) {
      return t('offerCard.soldOut');
    }

    if (isLimitReached) {
      return t('offerCard.limitReached');
    }

    return symbol ? `${symbol} ${price.toLocaleString()}` : price.toLocaleString();
  };

  return {
    mapBaseOfferToProps: (offer: BaseOffer): OfferCardProps => {
      const isLimitReached = offer.individualSupply === 0 && (offer.maxGlobalSupply === -1 || offer.globalSupply > 0);
      const isSoldOut = offer.globalSupply === 0;
      const isUnavailable = isLimitReached || isSoldOut;
      const isFiat = selectedCurrency === 'FIAT';
      const quantity = Object.values(offer.sku.items)[0];
      console.log('offer.endDate', offer.endDate);

      return ({
        name: offer.title[currentLang],
        bonus: offer.bonus ? `${offer.bonus.toLocaleString()}%` : undefined,
        expiredAt: offer.endDate ? new Date(offer.endDate) : undefined,
        expiredInLabelText: (timeLeft: string) => t('offerCard.expiresIn', { timeLeft }),
        imageUrl: offer.sku.imageUrl,
        backgroundUrl: offer.sku.backgroundUrl,
        buttonType: offer.sku.buttonType,
        buttonText: getButtonText(
          isSoldOut,
          isLimitReached,
          offer.price,
          isFiat ? selectedCountryInfo.currencySymbol : undefined,
        ),
        showPowerIcon: !isFiat,
        buttonSubtext: offer.usdcPrice ? `${offer.usdcPrice.toLocaleString()} ${t('offerCard.usdc')}` : undefined,
        isUnavailable,
        description: !isSoldOut ? getOfferDescription(offer, selectedOfferType) : undefined,
        checkout: () => { },
        hardResource: quantity,
        refreshTime: isLimitReached && offer.refreshTime ? new Date(offer.refreshTime) : undefined,
        displayOfferType: offer.sku.displayOfferType,
      });
    },
  };
};
